﻿import Vue from "vue";
import common from "../../common";
import context_ from "../context";
import core from "../../core";
import SecuriteUtilisateurEditVue_ from "../vue/SecuriteUtilisateurEditVue";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import FormNode_ from "../vue/hotEditable/FormNode";
import utilities_ from "../utilities";
import FormService_ from "../../services/FormService";
import config_ from "../config";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
const config = require("../config") as typeof config_;
// const SecuriteUtilisateurEditVue = require("../vue/SecuriteUtilisateurEditVue") as SecuriteUtilisateurEditVue_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const FormService = require("../../services/FormService") as FormService_;

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    /** Definie sur le mode "Edition" est constant ou s'il est "togglable" (default: false) */
    isEditionAlwaysOn?: boolean;
    /** Definie si, en mode "Edition", le formulaire doit avoir un bouton de sauvegarde ou si la sauvegarde est effectuee lors des changements de valeurs des champs (default: false) */
    liveUpdateOnEditMode?: boolean;
    liveUpdateOnEditModeIgnoredFieldNames?: string[];
    /** Format de l'url de la page pour le reload avec Id de l'utilisateur selectionne dans la liste (format: '/controller/action?id={id}' ) */
    pageUrlFormat: string;
    customData?: common.IPostCustomData;
}

class SecuriteUtilisateurEdit implements common.IWebComponent {
    private _isInit = false;
    private _formService?: FormService_;
    private _editVue = null as SecuriteUtilisateurEditVue_ | null;
    private _loader = null as core.Loader | null;
    private _previousPageUrl?: string | null;
    private _vueElId?: string;
    private _updateApiUrl?: string | null;
    private _liveUpdateOnEditMode?: boolean;
    private _liveUpdateOnEditModeIgnoredFieldNames?: string[];
    private _useBrowserHistoryToGoBackOnCancel?: boolean;
    private _pageUrlFormat?: string;
    private _customData = null as common.IPostCustomData | null;
    private _confirmPopup = null as core.ConfirmationPopup | null;
    private _liveUpdate = { canPost: true, timoutId: null as ReturnType<typeof setTimeout> | null };

    // Initialisation
    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || (() => { throw "La propriété 'settings.updateApiUrl' est requise."; })();
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._liveUpdateOnEditMode = s.liveUpdateOnEditMode === true;//default is FALSE
        this._liveUpdateOnEditModeIgnoredFieldNames = s.liveUpdateOnEditModeIgnoredFieldNames || [];
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl;
        this._pageUrlFormat = s.pageUrlFormat;
        this._customData = s.customData || {};
        this._formService = new FormService_(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#SecuriteUtilisateurEditPopup.mod-popup", null, null, null, null, '#SecuriteUtilisateurEditPopupBackground');

        this.setupVue(s);

        return context.components.add(this);
    }

    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName
        };

        this._editVue = new SecuriteUtilisateurEditVue_();
        this._editVue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        }).setErrorCallback((errors: common.IError[], config?: common.IHotEditableFormConfig) => {
            this.onFormActionError(errors, null, config);
        });

        this._editVue?.shared?.setupForm();
    }
    registerFormManagerParentNode(parent: FormNode_, containerFieldName: string, url: string | null) {
        if (this._editVue?.formManager?.formNode) {
            this._editVue.formManager.formNode.onRegister(containerFieldName, url, this);
            parent?.registerChildNode(this._editVue.formManager.formNode);
        }
        return this;
    }
    private onFormAction(action: HotEditableFormAction_) {
        if (this._formService?.actionHasError(action))
            return;

        if (action.isFieldChanged() && action.getFieldName() === 'IdUtilisateur') {
            const redirectUrl = this._pageUrlFormat?.replace('{id}', action.getFieldTextualValue() as any);
            utilities.redirect(redirectUrl);
            return;
        }

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        if (isEditionFormMode && this._liveUpdateOnEditMode) {
            if (this._liveUpdate.canPost) {
                this._liveUpdate.canPost = false;
                if (this._liveUpdate.timoutId)
                    clearTimeout(this._liveUpdate.timoutId);
                this._liveUpdate.timoutId = setTimeout(() => {
                    this._liveUpdate.canPost = true;
                }, config.liveUpdateMode.minDelayMsBetweenTwoAction);
            }

            else return;

            const isExcluded = utilities.any(this._liveUpdateOnEditModeIgnoredFieldNames, x => x === action.getFieldName());
            if (isExcluded)
                return;
            else if (actionType === common.HotEditableActionTypes.unknown)
                actionType = common.HotEditableActionTypes.update;
        }

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel) {
            utilities.redirect(this._previousPageUrl);
            return;
        }

        const post = () => {

            this._formService?.validateAndPost(
                this._updateApiUrl,
                null,
                {
                    posted_actionType: actionType,
                    posted_actionValue: actionValue,
                    posted_formName: this._editVue?.shared?.getFormName(),
                    posted_fieldName: action.getFieldName(),
                    posted_currentCulture: context.culture.get(),
                    posted_currentUrl: utilities.currentUrl(),
                    posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                    posted_previousPageUrl: this._previousPageUrl,
                    posted_isControlClick: action.getButtonClickContext().isCtlClick === true
                } as common.IHotEditableFormPostArguments,
                (data: common.IHotEditableFormResponseData) => {
                    this.onFormActionSuccess(action, data);
                },
                (e: any, config: any) => {
                    this.onFormActionError(e, action, config);
                });
        };

        if (this._liveUpdateOnEditMode)
            // NOTE: ajout d'un delai afin de permettre aux plugins de se mettre a jour.
            setTimeout(() => {
                post();
            }, 100)
        else
            post();
    }

    private onFormActionSuccess(action: HotEditableFormAction_, data?: common.IHotEditableFormResponseData) {
        data = data || {};

        const actionValue = action.getActionValue();
        const actionType = action.getActionType();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdated = isButtonClick && actionType === common.HotEditableActionTypes.update;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const changedFieldName = action.getFieldName();
        const buttonClickContext = action.getButtonClickContext();

        // if (data.outdatedContent)
        //     return this._pageService?.applyOutdatedContent(data, this._editVue);

        // Doit etre ouvert avant le refresh du widget si une URL de fichier typiquement en target=blank
        const openRedirectUrlInBlankPage = data.redirectUrl && utilities.openInBlankPage(data.redirectUrlOptions);
        if (openRedirectUrlInBlankPage)
            utilities.redirectWithDelay(data.redirectUrl, 1, true);

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (this._editVue?.shared)
                if (!this._editVue.shared.displayMessage(name, text, messageType))
                    this._formService?.displayMessage(text, messageType, immediateDisplay, autoClose);
        }

        if (isUpdated || data.redirectUrl) {
            const url = data.redirectUrl || this._previousPageUrl || null;

            if (url) {
                this._formService?.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                utilities.redirectWithOptions(url, data.redirectUrlOptions);
                return;
            }
        }

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue?.shared?.updateFieldFromApi(updatedField);
            }

        var succesMessageSended = false;
        if (showMessages)
            if (data.messages?.length) {
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
                // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                //     this._formService?.displayMessage(data.messages, customMessageType, true, true);
            }
            else if (showAutoSuccessMessages && !succesMessageSended) {
                this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                succesMessageSended = true;
            }

        if (isEditionFormMode && !this._liveUpdateOnEditMode)
            this._editVue?.shared?.setAsHotEditableFormMode();

        const repost = () => this._editVue?.shared?.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService_.confirm(
            this._editVue?.formManager?.getFormName(),
            this._confirmPopup,
            data.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            (returnToApiOnDenied: boolean) => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }

                if (this._editVue?.shared?.confirmationRejected())
                    this._formService?.displayNotSavedErrorMessageImediately();
            }))
            return;
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction_ | null, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {
                var e: core.Error;
                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    e = new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code);
                }
                else {
                    e = new core.Error(error.message);
                }

                this._formService?.displayErrorImediately(e);
                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue?.shared?.displayFieldError(this._editVue?.shared?.getFormName(), error, true);
            if (fieldFound) {
                this._formService?.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService?.displayErrorImediately(new core.Error(error.message));
        }
    }
}

export = SecuriteUtilisateurEdit;
